import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { useHistory } from 'react-router-dom';

import { setPreventUnload } from 'flow/actions/app-actions';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import {
    selectName,
    selectType,
    selectUrl,
} from 'flow/selectors/DashboardsSelectors';
import { DashboardKey, ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

import { generatePath } from 'flow/utils/router-utils';

interface Props {
    dashboardKey: DashboardKey;
    extensionKey: ExtensionKey;
}

const DashboardListItem = ({ dashboardKey, extensionKey }: Props) => {
    const { i18next } = useAppContext();
    const history = useHistory();

    const type = useAppSelector((state) => selectType(state, dashboardKey));
    const url = useAppSelector((state) => selectUrl(state, dashboardKey));
    const name = useAppSelector((state) => selectName(state, dashboardKey));

    const onOpenUrlClick = () => {
        setPreventUnload(true);
        window.open(url);
    };

    return (
        <div className="flex justify-between">
            <div className="flex gap-3">
                <img
                    className="h-[45px] w-[80px]"
                    src={require(`images/wallboard/${type}.png`)}
                    alt="Dashboard type"
                />
                <div className="flex min-w-0 flex-col justify-start gap-y-1 pe-1.5">
                    <div className="min-w-0 overflow-hidden font-bold text-ellipsis whitespace-nowrap">
                        {name}
                    </div>
                    <div
                        className="text-link min-w-0 cursor-pointer overflow-hidden text-sm text-ellipsis whitespace-nowrap"
                        onClick={onOpenUrlClick}
                    >
                        {url}
                    </div>
                </div>
            </div>
            <div className="flex items-center gap-x-3">
                <IconButton
                    aria-label={i18next.t('action.open')}
                    className="rounded-sm bg-gray-200"
                    onClick={onOpenUrlClick}
                    disabled={!url}
                >
                    <Icon iconKey="openInNew" />
                </IconButton>
                <IconButton
                    aria-label={i18next.t('Tooltip.Nav.Title.Edit')}
                    className="rounded-sm bg-gray-200"
                    onClick={() =>
                        history.push(
                            generatePath(routes['settings.dashboards.edit'], {
                                extensionKey,
                                wallboardKey: dashboardKey,
                            }),
                        )
                    }
                >
                    <Icon iconKey="edit" />
                </IconButton>
            </div>
        </div>
    );
};
export default React.memo(DashboardListItem);
